import React, { useEffect, useState } from "react";
import Input from "../../Components/Input/Input";
import { FilterWrapper } from "../../assets/styles/FilterStyle";
import { useNavigate, useLocation } from "react-router-dom";
import {
  diosmAadharKyc,
  diosmAadharOtpVerify,
  diosmVerifyPan,
  diosmVerifyPanConfirm,
  updateUserDaital,
} from "../../utils/api";

import { getDateFromDateObj, isEmpty, isIdPattern, isNumber } from "../../utils/common";
import { ModalPopUp } from "../../Components/ModalPopUp/ModalPopUp";
import modalpopup from "../../assets/images/modalPopubg.svg";
import animationData2 from "../../assets/lotties/done_msg.json";
import Lottie from "react-lottie";
import OTPInput from "react-otp-input";
import Swal from "sweetalert2";
import Spinner from "../../Components/spinner/Spinner";
import { DatePicker } from "antd";
import { getShopType } from "./constant";

const EditUserForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [otp, setOtp] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [editUserData, setEditUserData] = useState({});
  const [pan, setPan] = useState("");
  const [aadhar, setAddher] = useState("");
  const item = location.state;
  const [userData, setUserData] = useState({ ...item });
  const [reqId, setReqId] = useState("");
  const [btnLoader, setBtnLoader] = useState("");
  const [showOtpBox, setShowOtpBox] = useState(false);
  const [hideVerificationSec, setHideVerificationSec] = useState(true);
  const [nameOnPan, setNameOnPan] = useState("");
  const [dobOnPan, setDobOnPan] = useState("");

  const handleFormData = async (e) => {
    let error = {};
    if (userData.address1 === "") {
      error.address1 = "Please enter your address";
    } else if (userData.address1.length < 5) {
      error.address1 = "Address can't be less than 5 letters";
    }
    if (errors.dob === "") {
      error.dob = "Please enter your date of birth";
    }
    if (userData.phoneNumber === "") {
      error.phoneNumber = "Please enter your date of birth";
    }
    if (userData.email === "") {
      error.email = "Please enter your email";
    }
    if (userData.firstName === "") {
      error.firstName = "Please enter your full name";
    }
    // if (userData.lastName === "") {
    //   error.lastName = "Please enter your last name";
    // }
    if (userData.password === "") {
      error.password = "Please enter your password";
    }
    if (userData.pincode === "") {
      error.pincode = "Please enter your pincode";
    } else if (userData.pincode.length < 6) {
      error.pincode = "Pincode can't be less than 6";
    }
    if (userData.userName === "") {
      error.userName = "Please enter your username";
    } else if (userData.userName.length < 10) {
      error.userName = "Username can't be less than 10";
    }
    setErrors(error);
    if (isEmpty(error)) {
      setLoading(true);
      let {lastName, ...test} = userData;
      let params = test;


      updateUserDaital(params).then((response) => {
        setLoading(false);
        if (response?.data?.success) {
          setEditUserData({
            msg: "User details updated Successfully",
            type: "SUCCESS",
          });
        } else {
          let msg = "";
          if (response?.data?.errorCodeList.length > 0) {
            msg = response?.data?.errorCodeList[0];
          } else {
            msg = response?.data?.msg;
          }
          setEditUserData({ msg: msg, type: "errorbutton" });
        }
      });
    }
  };

  const handleInput = (e) => {
    const {name, value} = e.target
    setErrors({});
    setUserData({ ...userData, [name]: value });
  };
  const defaultOptions2 = {
    loop: true,
    autoplay: true,
    animationData: animationData2,
  };

  const userNavigate = () => {
    if (userData.userType === "ROLE_RETAILER") {
      navigate("/retailerList");
    } else {
      navigate("/usersList");
    }
  };

  useEffect(() => {
    setErrors({});
  }, [otp]);

  const changePan = (e) => {
    const value = e.target.value?.toUpperCase();
    if (!value && !isEmpty(value)) return;
    setErrors({});
    setPan(value);
  };
  const panName = (e) => {
    const value = e.target.value;
    setErrors({});
    setNameOnPan(value);
  };
  const changeDate = (date) => {
   
    setErrors({});
    setDobOnPan(date);
  };
  const changeAdhar = (e) => {
    const value = e.target.value;
    if (!isNumber(value) && !isEmpty(value)) return;
    setErrors({});
    setAddher(value);
  };


  const regexPan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
  const verifyPan = () => {
    setErrors({});
    const err = {}
    let dob = getDateFromDateObj(dobOnPan?.$d, "DD/MM/YYYY");
     if(!dobOnPan){
      err.dobOnPan = "Please enter your date of birth";
      
     }else{
       dob = getDateFromDateObj(dobOnPan?.$d, "DD/MM/YYYY");
     }
  
     
   
  
    if (isEmpty(pan)) {
      err.pan = "Pan number is required!" 

    } else if (!regexPan.test(pan)) {
      err.pan = "Please enter valid pan number!" ;

   
    } 
    

    if(isEmpty(nameOnPan)){
      err.nameOnPan = "Name is required!";
    }


    if ((dob === "Invalid date")) {
      err.dobOnPan = "Please enter your date of birth";
      

    
    } 
    setErrors({ ...errors,...err  });
    
    if(isEmpty(err)) {
       const param = {
          pan: pan,
          phoneNumber: item.userName,
          dob: dob,
         name: nameOnPan
        };
        setBtnLoader("pan");;
      diosmVerifyPan(param).then((resp) => {
        setBtnLoader("");
     
        if (resp?.data?.success) {
          setReqId(resp?.data?.data?.reqId);
          Swal.fire({
            icon: "success",
            text:
              resp?.data?.data?.userName +
              "! Are you sure this is you?",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            showCancelButton: true,
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
          }).then((result) => {
            if (result.isConfirmed) {
              confirmPan(resp?.data?.data?.reqId);
            } else if (result.dismiss === Swal.DismissReason.cancel) {
            }
          });
        } else {
          let msg = "";

          if (resp?.data?.errorCodeList?.length > 0) {
            msg = resp?.data?.errorCodeList[0];
          } else {
            msg = resp?.data?.msg;
          }
          Swal.fire({
            icon: "error",
            text: msg,
            confirmButtonColor: "#ED1C24" ,
          });
        } 
      });
    }
  };

  const confirmPan = (reqId) => {
    const param = {
      userId: "",
      reqId: reqId,
      pan: "",
    };
    setBtnLoader("pan");
    diosmVerifyPanConfirm(param).then((resp) => {
      setBtnLoader("");
      if (resp?.data?.success) {
        Swal.fire({
          icon: "success",
          text: "PAN verify successful",
          confirmButtonColor: "#3085d6",
        });
      } else {
        let msg = "";

        if (resp?.data?.errorCodeList?.length > 0) {
          msg = resp?.data?.errorCodeList[0];
        } else {
          msg = resp?.data?.msg;
        }
        Swal.fire({
          icon: "error",
          text: msg,
          confirmButtonColor: "#ED1C24",
        });
      }
    });
  };

  const sendOtp = () => {
    if (aadhar === "") {
      setErrors({ ...errors, aadhar: "Aadhar number is required!" });
    } else if (aadhar.length < 12) {
      setErrors({ ...errors, aadhar: "Please enter valid aadhar number" });
    } else {
      const param ={
        aadhaar: aadhar,
        phoneNumber: item.userName,
      }
      setBtnLoader("otp");
    
      diosmAadharKyc(param).then((resp) => {
       
        if (resp?.data?.success) {
          setBtnLoader("resend");
          setShowOtpBox(true)
          let msg =""
          setReqId(resp?.data?.data?.response?.data?.requestId);
          if(resp?.data?.data?.message === "Upstream Down"){
            setBtnLoader("");
            setShowOtpBox(false);
            msg = "Please try after 5 minutes";

          }else{
            msg ="Otp sent successfully."
          }
         Swal.fire({
            icon: "error",
            text: msg,
            confirmButtonColor: "#3085d6",
          });
        } else {
          setBtnLoader("");
          setShowOtpBox(false);
          let msg = "";

          if (resp?.data?.errorCodeList?.length > 0) {
            msg = resp?.data?.errorCodeList[0];
          } else {
            msg = resp?.data?.msg;
          }
          Swal.fire({
            icon: "error",
            text: msg,
            confirmButtonColor: "#ED1C24",
          });
        }
      });
    }
  };

  const vefifyOtp = () => {
 
    if (otp === "") {
      setErrors({ ...errors, otp: "OTP  is required!" });
    } else if (otp.length < 6) {
      setErrors({ ...errors, otp: "Please enter valid otp number" });
    } else {
      const param = {
        requestId: reqId,
        otp: otp
      }
      setBtnLoader("verify");
      diosmAadharOtpVerify(param).then((resp) => {
        setBtnLoader("");
        if (resp?.data?.success) {
          setHideVerificationSec(false);
          Swal.fire({
            icon: "success",
            text: "OTP verify successful",
            confirmButtonColor: "#3085d6",
          });
        } else {
          let msg = "";

          if (resp?.data?.errorCodeList?.length > 0) {
            msg = resp?.data?.errorCodeList[0];
          } else {
            msg = resp?.data?.msg;
          }
          Swal.fire({
            icon: "error",
            text: msg,
            confirmButtonColor: "#ED1C24",
          });
        }
      });
    }
  };

  console.log("errors",item)

 
  return (
    <div className="main_container" style={{ padding: "60px 40px 40px" }}>
      <FilterWrapper>
        <div>
          <label
            style={{
              color: "rgb(240 241 243)",
              fontSize: "25px",
              fontWeight: "bold",
              fontFamily: "'Cabin', sans-serif",
            }}
          >
            Edit Details
          </label>
        </div>
      </FilterWrapper>
      <div className="container_form">
        <div className="shadowBox">
          <div className="role" style={{display:"inline-block"}}>
            <div className="retailer">
              <label className="label_head">Personal Details</label>
            </div>
          </div>
          <div className="role role_responsive">
            <div className="retailer">
              <div className="labelname">
                <label>UserName</label>
                <span className="required">*</span>
              </div>
              <Input
                type="text"
                placeholder="enter you username"
                name="userName"
                value={userData.userName}
              />
            </div>
            <div className="retailer">
              <div className="labelname">
                <label>FullName</label>
                <span className="required">*</span>
              </div>
              <div>
                <Input
                  className="inputtype"
                  type="text"
                  placeholder="enter you fullName"
                  name="firstName"
                  value={userData.firstName}
                  onChange={handleInput}
                />
                {errors.firstName && (
                  <p className="error fs-12 mt-10">{errors.firstName}</p>
                )}
              </div>
            </div>
          </div>
          <div className="role role_responsive">
           
            {/* <div className="retailer">
              <div className="labelname">
                <label>Lastname</label>
                <span className="required">*</span>
              </div>
              <Input
                className="inputtype"
                type="text"
                placeholder="enter you lastName"
                name="lastName"
                value={userData.lastName}
                onChange={handleInput}
              />
              {errors.lastName && (
                <p className="error fs-12 mt-10">{errors.lastName}</p>
              )}
            </div> */}
            <div className="retailer">
              <div className="labelname">
                <label>DOB</label>
                <span className="required">*</span>
              </div>
              <div>
                <Input type="text" name="dob" value={userData.dob} />
              </div>
            </div>
          </div>
     

          <div className="role" style={{display:"inline-block"}}>
            <div className="retailer">
              <label className="label_head">Contact Details</label>
            </div>
          </div>

          <div className="role role_responsive">
            <div className="retailer">
              <div className="labelname">
                <label>Contact Number</label>
                <span className="required"> *</span>
              </div>
              <div>
                <Input
                  type="text"
                  placeholder="enter you mobile number"
                  name="phoneNumber"
                  value={userData.userName}
                />
              </div>
            </div>
            <div className="retailer">
              <div className="labelname">
                <label>Email Address</label>
                <span className="required"> *</span>
              </div>
              <Input
                type="text"
                placeholder="enter you email"
                name="email"
                value={userData.email}
                // onChange={handleInput}
              />
              {errors.email && (
                <p className="error fs-12 mt-10">{errors.email}</p>
              )}
            </div>
          </div>
          {/* Address Details */}
          <div className="role" style={{display:"inline-block"}}>
            <div className="retailer">
              <label className="label_head">Address Details</label>
            </div>
          </div>
          <div className="role role_responsive">
            <div className="retailer">
              <div className="labelname">
                <label>Address1</label>
                <span className="required"> *</span>
              </div>
              <div>
                <Input
                  type="text"
                  placeholder="enter you address"
                  name="address1"
                  value={userData.address1}
                  onChange={handleInput}
                />
                {errors.address1 && (
                  <p className="error fs-12 mt-10">{errors.address1}</p>
                )}
              </div>
            </div>
            <div className="retailer">
              <div className="labelname">
                <label>Address2</label>
              </div>
              <Input
                type="text"
                placeholder="enter you address2"
                name="address2"
                value={userData.address2}
                onChange={handleInput}
              />
            </div>
          </div>
          <div className="role role_responsive">
            <div className="retailer">
              <div className="labelname">
                <label>Landmark</label>
              </div>
              <div>
                <Input
                  type="text"
                  placeholder="enter you landmark"
                  name="landmark"
                  value={userData.landmark}
                  onChange={handleInput}
                />
              </div>
            </div>
            <div className="retailer">
              <div className="labelname">
                <label>Picode</label>
                <span className="required"> *</span>
              </div>
              <Input
                type="text"
                placeholder="enter you pincode"
                name="pincode"
                value={userData.pincode}
                onChange={handleInput}
                maxLength={6}
              />{" "}
              {errors.pincode && (
                <p className="error fs-12 mt-10">{errors.pincode}</p>
              )}
            </div>
          </div>
          <div className="role role_responsive">
           <div className="">
                <div className="labelname">
                  <label>Business Type</label>
                  <span className="required"> *</span>
                </div>
                <div className="input-field">
                  <select
                    className="input_select_field"
                    value={userData?.businessType}
                    name="businessType"
                    onChange={handleInput}
                  >
                    <option value={""}>select</option>
                    {
                      getShopType && getShopType.map((val,i) =>{
                        return  <option key={i} value={val?.mccCode}>{val?.mccDescription}</option>
                      })
                    }
                  

                   
                  
                  </select>
                  {errors.userType && (
                    <p className="error fs-12 mt-10">{errors.businessType}</p>
                  )}
                </div>
              </div>
          </div>
          <div className="role role_responsive">
            <div className="retailer">
              <div className="labelname">
                <label>Pan</label>
              </div>
              <div>
                <Input
                  type="text"
                  placeholder="enter you landmark"
                  name="landmark"
                  value={userData.isPanVerified?"Verified":"Not Verified"}
               
                />
              </div>
            </div>
            <div className="retailer">
              <div className="labelname">
                <label>Aadhar</label>
                <span className="required"> </span>
              </div>
              <Input
                type="text"
                placeholder="Aadhar status"
                name="aadhar"
                value={userData.isAadhaarVerified?"Verified":"Not Verified"}
              />
            
            </div> 
          </div>

         

          <div className="role">
            <div className="retailer">
              <button
                className="submit_btn"
                onClick={() => {
                  handleFormData();
                }}
              >
                {loading ? <Spinner /> : "Update"}
              </button>
            </div>
          </div>
        </div>
       {(userData?.userType === "ROLE_RETAILER") && hideVerificationSec &&  <>
      
        {<div className="shadowBox">
          <div className="">
            <div className="">
              <h3>Pan Details</h3>
            </div>
          </div>
          <div className="role role_responsive">
          <div className="verification">
              <div className="labelname">
                <label>Pan Card Number</label>
                <span className="required"> *</span>
              </div>
              <div>
                <Input
                  type="text"
                  name="pannumber"
                  pattern="[0-9]*"
                  maxLength={10}
                  placeholder="Enter your pan number"
                  value={pan}
                  onChange={(e) => changePan(e)}
                />

                {errors.pan && (
                  <p className="error mt-10 fs-12">{errors.pan}</p>
                )}
              </div>
            </div>
           <div className="retailer">
              <div className="labelname">
                <label>Name on Pan</label>
              </div>
              <div>
                <Input
                  type="text"
                  placeholder="Enter name on Pan"
                  name="nameOnPan"
                  value={nameOnPan}
                  onChange={panName}
                />
                {errors.nameOnPan && (
                  <p className="error mt-10 fs-12">{errors.nameOnPan}</p>
                )}
              </div>
            </div> 
              {/* <div
              className="verification"
              style={{ flex: "1 1 200px", maxWidth: "330px", alignSelf: "end" }}
            >
            { btnLoader ==="pan"?
            <button
            className="submit_btn center gap-10"
            disabled
          >
            <Spinner /> Verify PAN
          </button>
            :  <button className="submit_btn" onClick={verifyPan}>
                Verify PAN
              </button>}
            </div> */}
          </div>
         <div className="id_verification role_responsive">
          <div className=" verification"
          style={{ flex: "1 1 200px", maxWidth: "330px", alignSelf: "end" }}
          
          >
              <div className="labelname">
                <label>DOB on Pan</label>
                <span className="required"> *</span>
              </div>
              <DatePicker
                  showIcon
                  className="flex justify-center colr"
                  placeholderText="Enter your DOB"
                  selected={dobOnPan}
                  valueDefault={null}
                  value={dobOnPan}
                
                  yearDropdownItemNumber={100}
                  scrollableYearDropdown={true}
                  // yearDropdownMin={new Date()}
                  showYearDropdown
                  onKeyDown={(e) => e.preventDefault()}
                  onChange={(date) => {
                    changeDate(date);
                  }}
                />
              {errors.dobOnPan && (
                <p className="error fs-12 mt-10">{errors.dobOnPan}</p>
              )}
            </div>
         
            <div
              className="verification"
              style={{ flex: "1 1 200px", maxWidth: "330px", alignSelf: "end" }}
            >
            { btnLoader ==="pan"?
            <button
            className="submit_btn center gap-10"
            disabled
          >
            <Spinner /> Verify PAN
          </button>
            :  <button className="submit_btn" onClick={verifyPan}>
                Verify PAN
              </button>}
            </div>
          </div> 
        </div>}
        {
        <div className="shadowBox">
          <div className=" ">
            <div className="">
              <h3>Aadhar Details</h3>
            </div>
          </div>
          <div className="id_verification role_responsive">
            <div className="verification">
              <div className="labelname">
                <label>Aadhar Card Number</label>
                <span className="required"> *</span>
              </div>
              <div>
                <Input
                  type="text"
                  name="adharnumber"
                  pattern="[0-9]*"
                  maxLength={12}
                  placeholder="Enter your aadhar number"
                  value={aadhar}
                 // disabled={isEmpty(reqId)}
                  onChange={(e) => {
                    changeAdhar(e);
                  }}
                />

                {errors.aadhar && (
                  <p className="error mt-10 fs-12">{errors.aadhar}</p>
                )}
              </div>
            </div>
            <div
              className="verification"
              style={{ flex: "1 1 200px", maxWidth: "330px", alignSelf: "end" }}
            >
               { btnLoader ==="otp"?
            <button
            className="submit_btn center gap-10"
            disabled
          >
            <Spinner /> Send otp
          </button>
            :    <button className="submit_btn" onClick={sendOtp}>
           {btnLoader ==="resend"? "Resend otp":"Send otp"}
          </button>}
            
            </div>
          </div>

          {showOtpBox &&<div className="id_verification role_responsive">
            <div
              className="verification"
              style={{ width: "clamp(200px, 100%, 330px)" }}
            >
              <div className="labelname">
                <label>Enter otp</label>
                <span className="required"> *</span>
              </div>
              <div className="otp_container">
                <OTPInput
                  value={otp}
                  inputStyle={{
                    width: "50px",
                    height: "50px",
                    background: " #c8c7c7 0% 0% no-repeat padding-box",
                    border: "5px",
                    opacity: 1,
                  }}
                  onChange={!isEmpty(aadhar) ? setOtp : () => {}}
                  numInputs={6}
                  renderInput={(props) => <input {...props}  disabled={isEmpty(aadhar)} />}
                />
              </div>
              {errors.otp && <p className="error mt-10 fs-12">{errors.otp}</p>}
            </div>
            <div
              className="verification"
              style={{ flex: "1 1 200px", maxWidth: "330px", alignSelf: "end" }}
            >
                 { btnLoader ==="verify"?
            <button
            className="submit_btn center gap-10"
            disabled
          >
            <Spinner /> Verify otp
          </button>
            : <button className="submit_btn" onClick={vefifyOtp}>
            Verify otp
          </button>}
              
            </div>
          </div>}
        </div>}
        </>}
      </div>

      {!isEmpty(editUserData) && (
        <ModalPopUp>
          ""
          <div
            className={
              `${editUserData.type} && ${editUserData.type === "errorbutton"}`
                ? "error-popup"
                : "modal-popup"
            }
            style={{
              backgroundImage: `url(${modalpopup})`,
              backgroundRepeat: "no-repeat",
              backgroundPositionX: "right",
              backgroundPositionY: "bottom",
            }}
          >
            <>
              {editUserData.type === "SUCCESS" && (
                <>
                  <div>
                    <Lottie
                      options={defaultOptions2}
                      height={80}
                      width={80}
                    ></Lottie>
                  </div>

                  <div className="flex justify-center ">
                    <label className="fs25 blue_font fw-bold">Done!</label>
                  </div>
                </>
              )}
              <div
                className={`flex justify-center ${
                  editUserData.type === "errorbutton" ? "mt-30" : ""
                }`}
              >
                <label>{editUserData.msg}</label>
              </div>
              <div className="flex justify-center gap-10 mt-16">
                {editUserData.type === "SUCCESS" && (
                  <button
                    className="confirm_button"
                    onClick={() => setEditUserData("")}
                  >
                    Close
                  </button>
                )}

                {editUserData.type === "errorbutton" && (
                  <button
                    className="error_button "
                    onClick={() => setEditUserData("")}
                  >
                    OK
                  </button>
                )}
              </div>
            </>
          </div>
        </ModalPopUp>
      )}
    </div>
  );
};

export default EditUserForm;
